module.exports = __webpack_public_path__ + "static/img/sxt.4985f037.png";